import { useState } from 'react';
import { Button, Icon, HideText } from '@fashionnovateam/nova-ui-toolkit';
import { Link } from 'react-router-dom';
import Page from '../Page/index.ts';
import Header from '../Header/index.ts';
import VendorApplicationsDataGrid from './VendorApplicationsDataGrid.tsx';
import { hasAccessTo } from '../../Lib/Constants/roles.ts';

export default function VendorApplications({ currentUser }) {
  const [filter, setFilter] = useState('inProgress');
  const [search, setSearch] = useState('');

  const handleFilterChange = (newValue) => setFilter(newValue);
  const handleSearchChange = (newValue) => setSearch(newValue);

  return (
    <Page.Container>
      <Header.Major icon="clipboard/clipboard-text" title="Vendor Applications">
        {hasAccessTo(
          'vendor-applications/initiate-vendor-application',
          currentUser.role,
        ) && (
          <Link to="/vendor-applications/initiate-vendor-application">
            <Button color="primary" size="sm">
              <Icon.PlusSquare variant="solid" />
              <HideText notAbove="lg">Create{'\u00A0'}Application</HideText>
            </Button>
          </Link>
        )}
      </Header.Major>
      <Header.Minor
        search={{ value: search, onChange: handleSearchChange }}
        filter={{
          value: filter,
          onChange: handleFilterChange,
          items: [
            {
              icon: 'circle-dot',
              value: 'inProgress',
              label: 'In Progress',
            },
            {
              icon: 'check/check-tick-circle',
              value: 'approved',
              label: 'Approved',
            },
            {
              icon: 'ban/ban-right',
              value: 'denied',
              label: 'Denied',
            },
            {
              icon: 'folder/folder-arrow-down',
              value: 'archived',
              label: 'Archived',
            },
            {
              icon: 'file/file-text',
              value: 'all',
              label: 'All',
            },
          ],
        }}
      />
      <Page.Content>
        <VendorApplicationsDataGrid
          filter={filter}
          search={search}
          userRole={currentUser.role}
        />
      </Page.Content>
    </Page.Container>
  );
}
